import { getRouteApi } from '@tanstack/react-router';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { LuEye, LuEyeOff } from 'react-icons/lu';

import type { Credit } from '../../../types';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import { cn } from '~/utils/cnTailwind';

type Props = {
    credit: Credit;
    index: number;
    toggleHide: (index: number) => void;
    prefix: string;
};

export const HideCell: React.FC<Props> = ({ credit, index, prefix, toggleHide }) => {
    const { t } = useTranslation();
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const disabled = !permissions.commands[AGGREGATE_NAMES.LOAN_REQUEST].changeLiabilityHideState;

    return (
        <td onClick={(e) => e.stopPropagation()}>
            <button
                type="button"
                id={`${prefix}-hide-checkbox-${index}`}
                aria-label={t(
                    credit.hide
                        ? 'BANK_CREDIT_REQUEST.REFINANCE_PLANNER.HIDE_CHECKBOX_TRUE'
                        : 'BANK_CREDIT_REQUEST.REFINANCE_PLANNER.HIDE_CHECKBOX_FALSE',
                )}
                className={cn('relative z-10 inline-flex cursor-pointer', disabled && 'opacity-50 cursor-not-allowed')}
                onClick={() => toggleHide(index)}
                disabled={disabled}
            >
                {credit.hide ? (
                    <LuEyeOff className="size-5 text-red-600" data-testid="eye-crossed-icon" />
                ) : (
                    <LuEye className="size-5 text-midnight" data-testid="eye-icon" />
                )}
            </button>
        </td>
    );
};
